import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from './TempCartContext';

const CartIcon = () => {
  const { cart } = useCart();
  const location = useLocation();
  const navigate = useNavigate();

  const itemCount = cart.products.reduce((total, item) => total + item.quantity, 0);

  // Hide cart on admin pages and cart page itself
  const isAdminPage = location.pathname.startsWith('/admin');
  const isCartPage = location.pathname.startsWith('/cart');

  if (isAdminPage || isCartPage) {
    return null;
  }

  return (
    <div className="fixed z-[100]" style={{ top: '100px', right: '16px' }}>
      <button
        onClick={() => navigate('/cart')}
        className="backdrop-blur-xl bg-white/30 text-black p-3 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3),0_4px_12px_rgba(0,0,0,0.2)] hover:shadow-[0_15px_35px_rgba(0,0,0,0.4),0_6px_20px_rgba(0,0,0,0.3)] hover:scale-105 transition-all duration-200"
        aria-label="Open basket"
      >
        <div className="relative">
          <ShoppingCart className="w-12 h-12" strokeWidth={1.5} />
          {itemCount > 0 && (
            <span className="absolute -top-3 -right-3 bg-red-500 text-white text-sm rounded-full w-6 h-6 flex items-center justify-center font-bold">
              {itemCount > 99 ? '99+' : itemCount}
            </span>
          )}
        </div>
      </button>
      <div className="text-center mt-2">
        <div className="text-xs font-semibold text-gray-700 bg-white/30 backdrop-blur-sm px-2 py-1 rounded-full shadow-sm">
          <div>Your basket</div>
          <div>has {itemCount} {itemCount === 1 ? 'item' : 'items'}</div>
        </div>
      </div>
    </div>
  );
};

export default CartIcon;
